import { useState } from 'react';
import { ArrowRight, Home, Building2, Palette, Hammer, Key, MapPin, Ruler, IndianRupee, Phone, MessageCircle, Filter, BedDouble, Bath, Car } from 'lucide-react';

const WHATSAPP_NUMBER = '918880331224';

// Quick Services (simplified)
const quickServices = [
  { icon: Home, title: 'Residential Construction', desc: 'Custom homes & villas' },
  { icon: Building2, title: 'Commercial Construction', desc: 'Offices, shops & warehouses' },
  { icon: Palette, title: 'Interior Design', desc: 'Modern & elegant interiors' },
  { icon: Hammer, title: 'Renovation', desc: 'Home & office makeovers' },
  { icon: Key, title: 'Turnkey Projects', desc: 'Ready-to-move solutions' },
];

// Property Types for filtering
const propertyTypes = ['All', 'Residential Plot', 'House/Villa', 'Apartment', 'Commercial', 'Agricultural Land'];

// Property Listings - Add new properties here
const properties = [
  {
    id: 1,
    title: 'Prime Residential Plot',
    type: 'Residential Plot',
    location: 'Sedam Road, Kalaburagi',
    price: '₹25 Lakhs',
    pricePerSqft: '₹1,500/sq.ft',
    area: '1500 sq.ft',
    dimensions: '30 x 50 ft',
    facing: 'East Facing',
    image: 'https://images.unsplash.com/photo-1685266326473-5b99c3d08a7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMHBsb3QlMjBsYW5kJTIwZm9yJTIwc2FsZSUyMGVtcHR5fGVufDB8fHx8MTc3MzY0MDU2M3ww&ixlib=rb-4.1.0&q=85',
    featured: true,
    status: 'Available',
    highlights: ['Corner Plot', 'Near Main Road', 'Clear Title'],
  },
  {
    id: 2,
    title: '3BHK Independent House',
    type: 'House/Villa',
    location: 'Brahmapur, Kalaburagi',
    price: '₹85 Lakhs',
    pricePerSqft: '₹4,250/sq.ft',
    area: '2000 sq.ft',
    bedrooms: 3,
    bathrooms: 3,
    parking: 1,
    facing: 'North Facing',
    image: 'https://images.unsplash.com/photo-1759355787174-044355f63c55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGZvciUyMHNhbGUlMjByZXNpZGVudGlhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzczNjQwNTY0fDA&ixlib=rb-4.1.0&q=85',
    featured: true,
    status: 'Available',
    highlights: ['Fully Furnished', 'Modular Kitchen', 'Garden Area'],
  },
  {
    id: 3,
    title: 'Commercial Shop Space',
    type: 'Commercial',
    location: 'Super Market, Kalaburagi',
    price: '₹45 Lakhs',
    pricePerSqft: '₹7,500/sq.ft',
    area: '600 sq.ft',
    facing: 'Main Road Facing',
    image: 'https://images.unsplash.com/photo-1692133226337-55e513450a32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwc2hvcCUyMG9mZmljZSUyMHNwYWNlJTIwZm9yJTIwcmVudCUyMHNhbGV8ZW58MHx8fHwxNzczNjQwNTY1fDA&ixlib=rb-4.1.0&q=85',
    featured: false,
    status: 'Available',
    highlights: ['Ground Floor', 'High Footfall Area', 'Parking Available'],
  },
  {
    id: 4,
    title: 'Residential Plot in Layout',
    type: 'Residential Plot',
    location: 'Ring Road, Kalaburagi',
    price: '₹18 Lakhs',
    pricePerSqft: '₹1,200/sq.ft',
    area: '1500 sq.ft',
    dimensions: '30 x 50 ft',
    facing: 'West Facing',
    image: 'https://images.unsplash.com/photo-1565027526457-263723b95824?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxyZXNpZGVudGlhbCUyMHBsb3QlMjBsYW5kJTIwZm9yJTIwc2FsZSUyMGVtcHR5fGVufDB8fHx8MTc3MzY0MDU2M3ww&ixlib=rb-4.1.0&q=85',
    featured: false,
    status: 'Available',
    highlights: ['Approved Layout', 'All Amenities', 'Loan Available'],
  },
  {
    id: 5,
    title: '2BHK Apartment',
    type: 'Apartment',
    location: 'Jagat Circle, Kalaburagi',
    price: '₹42 Lakhs',
    pricePerSqft: '₹3,500/sq.ft',
    area: '1200 sq.ft',
    bedrooms: 2,
    bathrooms: 2,
    parking: 1,
    facing: 'South Facing',
    image: 'https://images.unsplash.com/photo-1770386286713-3614cd92c272?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGZvciUyMHNhbGUlMjByZXNpZGVudGlhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzczNjQwNTY0fDA&ixlib=rb-4.1.0&q=85',
    featured: false,
    status: 'Available',
    highlights: ['Gated Community', 'Lift Available', '24/7 Security'],
  },
  {
    id: 6,
    title: 'Agricultural Land',
    type: 'Agricultural Land',
    location: 'Aland Road, Kalaburagi',
    price: '₹35 Lakhs',
    pricePerSqft: '₹80/sq.ft',
    area: '1 Acre',
    facing: 'Highway Adjacent',
    image: 'https://images.unsplash.com/photo-1765690240647-fa0064e864bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMHBsb3QlMjBsYW5kJTIwZm9yJTIwc2FsZSUyMGVtcHR5fGVufDB8fHx8MTc3MzY0MDU2M3ww&ixlib=rb-4.1.0&q=85',
    featured: false,
    status: 'Available',
    highlights: ['Water Source', 'Electricity Available', 'Good Soil'],
  },
  {
    id: 7,
    title: 'Office Space for Sale',
    type: 'Commercial',
    location: 'Station Road, Kalaburagi',
    price: '₹65 Lakhs',
    pricePerSqft: '₹6,500/sq.ft',
    area: '1000 sq.ft',
    facing: 'East Facing',
    image: 'https://images.unsplash.com/photo-1666718622024-dc6bdc808bda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwc2hvcCUyMG9mZmljZSUyMHNwYWNlJTIwZm9yJTIwcmVudCUyMHNhbGV8ZW58MHx8fHwxNzczNjQwNTY1fDA&ixlib=rb-4.1.0&q=85',
    featured: false,
    status: 'Available',
    highlights: ['Furnished', 'AC Installed', 'Ready to Move'],
  },
  {
    id: 8,
    title: '4BHK Luxury Villa',
    type: 'House/Villa',
    location: 'GDA Layout, Kalaburagi',
    price: '₹1.2 Cr',
    pricePerSqft: '₹4,800/sq.ft',
    area: '2500 sq.ft',
    bedrooms: 4,
    bathrooms: 4,
    parking: 2,
    facing: 'North-East Facing',
    image: 'https://images.unsplash.com/photo-1767740680468-d5430d073da4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxob3VzZSUyMGZvciUyMHNhbGUlMjByZXNpZGVudGlhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzczNjQwNTY0fDA&ixlib=rb-4.1.0&q=85',
    featured: true,
    status: 'Available',
    highlights: ['Premium Location', 'Modern Design', 'Garden & Parking'],
  },
];

export default function Services() {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredProperties = activeFilter === 'All' 
    ? properties 
    : properties.filter(p => p.type === activeFilter);

  const handleEnquiry = (property) => {
    const message = encodeURIComponent(
      `*Property Enquiry*\n\n` +
      `*Property:* ${property.title}\n` +
      `*Location:* ${property.location}\n` +
      `*Price:* ${property.price}\n` +
      `*Area:* ${property.area}\n\n` +
      `I am interested in this property. Please share more details.`
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  const handleServiceEnquiry = (serviceName) => {
    const message = encodeURIComponent(`Hello! I am interested in your ${serviceName} services. Please provide more details.`);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div className="noise-overlay pt-24" data-testid="services-page">
      {/* Hero Section */}
      <section className="py-12 md:py-16 bg-[#ececec]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center max-w-3xl mx-auto">
            <span className="text-[#C9A646] text-xs uppercase tracking-[0.2em] font-bold">
              Our Services
            </span>
            <h1 className="font-heading text-4xl md:text-6xl text-gray-900 mt-4">
              Building Dreams,<br />
              <span className="text-[#8B4513] font-bold">Selling Properties</span>
            </h1>
            <p className="text-gray-600 text-base mt-4">
              Construction, Interior Design & Real Estate Solutions - All Under One Roof
            </p>
          </div>
        </div>
      </section>

      {/* Quick Services Grid */}
      <section className="py-12 bg-[#f5f5f5] border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {quickServices.map((service, index) => (
              <button
                key={service.title}
                onClick={() => handleServiceEnquiry(service.title)}
                className="p-4 bg-white border border-gray-200 rounded-xl hover:border-[#C9A646]/50 hover:shadow-md transition-all text-center group"
              >
                <service.icon size={28} className="mx-auto text-[#C9A646] group-hover:scale-110 transition-transform" />
                <h3 className="text-gray-900 text-sm font-semibold mt-2">{service.title}</h3>
                <p className="text-gray-500 text-xs mt-1">{service.desc}</p>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Real Estate Section - Main Highlight */}
      <section className="py-16 md:py-20 bg-[#ececec]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {/* Section Header */}
          <div className="text-center mb-10">
            <span className="text-[#C9A646] text-xs uppercase tracking-[0.2em] font-bold">
              Real Estate
            </span>
            <h2 className="font-heading text-4xl md:text-5xl text-gray-900 mt-4 font-bold">
              Properties for Sale
            </h2>
            <p className="text-gray-600 mt-3 max-w-xl mx-auto">
              Find your perfect property in Kalaburagi & surrounding areas
            </p>
          </div>

          {/* Filter Tabs */}
          <div className="flex items-center gap-3 overflow-x-auto pb-4 mb-8 scrollbar-hide">
            <Filter size={18} className="text-[#C9A646] flex-shrink-0" />
            {propertyTypes.map((type) => (
              <button
                key={type}
                onClick={() => setActiveFilter(type)}
                className={`px-4 py-2 text-sm font-medium whitespace-nowrap transition-all rounded-lg ${
                  activeFilter === type
                    ? 'bg-gradient-to-r from-[#C9A646] to-[#E6C36A] text-[#0A0A0A]'
                    : 'bg-white text-gray-600 hover:text-gray-900 border border-gray-200'
                }`}
              >
                {type}
              </button>
            ))}
          </div>

          {/* Properties Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProperties.map((property, index) => (
              <div
                key={property.id}
                className={`group bg-white border border-gray-200 rounded-2xl overflow-hidden hover:border-[#C9A646]/30 transition-all duration-300 ${
                  property.featured ? 'ring-2 ring-[#C9A646]/30' : ''
                }`}
                data-testid={`property-${property.id}`}
              >
                  {/* Image */}
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={property.image}
                      alt={property.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#ececec] via-transparent to-white/0" />
                    
                    {/* Status Badge */}
                    <div className="absolute top-3 left-3">
                      <span className={`px-3 py-1 text-xs font-bold rounded-full ${
                        property.status === 'Available' 
                          ? 'bg-green-500/90 text-gray-900' 
                          : 'bg-red-500/90 text-gray-900'
                      }`}>
                        {property.status}
                      </span>
                    </div>
                    
                    {/* Featured Badge */}
                    {property.featured && (
                      <div className="absolute top-3 right-3">
                        <span className="px-3 py-1 text-xs font-bold rounded-full bg-[#C9A646] text-[#0A0A0A]">
                          Featured
                        </span>
                      </div>
                    )}

                    {/* Price */}
                    <div className="absolute bottom-3 left-3">
                      <span className="text-2xl font-heading text-gray-900">{property.price}</span>
                      {property.pricePerSqft && (
                        <span className="text-xs text-gray-600 block">{property.pricePerSqft}</span>
                      )}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-4">
                    {/* Type Badge */}
                    <span className="text-[#C9A646] text-xs uppercase tracking-wider font-semibold">
                      {property.type}
                    </span>
                    
                    {/* Title */}
                    <h3 className="font-heading text-xl text-gray-900 mt-1 line-clamp-1 font-bold">
                      {property.title}
                    </h3>
                    
                    {/* Location */}
                    <p className="text-gray-600 text-sm flex items-center gap-1 mt-1">
                      <MapPin size={14} className="text-[#C9A646]" />
                      {property.location}
                    </p>

                    {/* Details Row */}
                    <div className="flex items-center gap-4 mt-3 text-gray-600 text-sm">
                      <span className="flex items-center gap-1">
                        <Ruler size={14} />
                        {property.area}
                      </span>
                      {property.bedrooms && (
                        <span className="flex items-center gap-1">
                          <BedDouble size={14} />
                          {property.bedrooms} BHK
                        </span>
                      )}
                      {property.bathrooms && (
                        <span className="flex items-center gap-1">
                          <Bath size={14} />
                          {property.bathrooms}
                        </span>
                      )}
                      {property.dimensions && (
                        <span className="flex items-center gap-1">
                          {property.dimensions}
                        </span>
                      )}
                    </div>

                    {/* Highlights */}
                    <div className="flex flex-wrap gap-2 mt-3">
                      {property.highlights.slice(0, 3).map((highlight) => (
                        <span key={highlight} className="text-xs px-2 py-1 bg-[#ececec] text-gray-600 rounded">
                          {highlight}
                        </span>
                      ))}
                    </div>

                    {/* Enquiry Button */}
                    <button
                      onClick={() => handleEnquiry(property)}
                      className="mt-4 w-full bg-gradient-to-r from-[#25D366] to-[#128C7E] text-gray-900 font-semibold py-3 rounded-xl flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
                      data-testid={`enquiry-btn-${property.id}`}
                    >
                      <MessageCircle size={18} />
                      Enquire on WhatsApp
                    </button>
                  </div>
                </div>
              ))}
          </div>

          {filteredProperties.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-600">No properties found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#C9A646] to-[#E6C36A]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-[#1a1a1a] font-bold">
              Have a Property to Sell?
            </h2>
            <p className="text-[#1a1a1a]/80 mt-3">
              List your property with us and reach thousands of potential buyers
            </p>
            <button
              onClick={() => {
                const message = encodeURIComponent('Hello! I want to list my property for sale. Please help me with the process.');
                window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
              }}
              className="mt-6 bg-[#1a1a1a] text-white font-semibold px-8 py-4 rounded-xl hover:bg-[#333] transition-colors inline-flex items-center gap-2"
            >
              <Phone size={18} />
              List Your Property
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
